/*
 * AsTools: filters in Coolblue-stijl (Harun, 26-09-2026), bovenop Search & Discovery.
 * Hoort bij snippets/astools-filters.liquid. Dit bestand laadt alleen als Thema-instellingen >
 * Filters (AsTools) > Filterweergave op Nieuw staat; bij Standaard laadt de sectie weer
 * facet-filters.js van Enterprise (ongewijzigd) en dit bestand niet.
 *
 * - Filteren zonder paginaverversing via de Section Rendering API, zoals Enterprise. Gaat dat mis,
 *   dan valt het terug op een gewone paginaverversing met dezelfde filters.
 * - Geen dubbele verzoeken: klikken worden 300 ms gebundeld, een lopend verzoek wordt afgebroken
 *   zodra er iets anders gekozen wordt, en een verzoek voor wat er al staat gaat niet de deur uit.
 * - Terug-knop: elke filterstand is een stap in de geschiedenis (pushState); popstate haalt hem op.
 * - Open/dicht, Toon meer en zoektermen blijven staan als de filters opnieuw getekend worden.
 */
/* global SideDrawer, theme */

if (!customElements.get('facet-filters')) {
  const WACHTTIJD = 300;
  // Prijsschuif: stand 0-1000 op een wortelschaal (bedrag = max x (stand/1000)^2), zodat de lage
  // bedragen, waar de meeste producten zitten, de meeste ruimte krijgen. Zelfde schaal als in de snippet.
  const STANDEN = 1000;
  const EIGEN_PARAMETER = /^(filter\.|sort_by$|q$|type$|options\[)/;
  const normaal = (tekst) => String(tekst || '')
    .toLowerCase()
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, '')
    .trim();

  class AstoolsFilters extends SideDrawer {
    connectedCallback() {
      if (!this.bij) {
        this.form = this.querySelector('#af-form');
        this.results = document.getElementById('filter-results');
        if (!this.form || !this.results) return;

        this.sectieId = this.form.dataset.filterSectionId;
        this.standaardSort = this.dataset.defaultSort || '';
        this.timer = null;
        this.controller = null;
        this.volgende = null;
        this.gebruikerOpen = new Map();
        this.gebruikerMeer = new Set();

        this.bij = {
          klik: this.onKlik.bind(this),
          wijzig: this.onWijzig.bind(this),
          invoer: this.onInvoer.bind(this),
          verstuur: this.onVerstuur.bind(this),
          toetsOmlaag: this.onToetsOmlaag.bind(this),
          toetsOmhoog: this.onToetsOmhoog.bind(this),
          pagKlik: this.onPaginaKlik.bind(this),
          pagWijzig: this.onPaginaWijzig.bind(this),
          terug: this.onTerug.bind(this),
          breekpunt: this.onBreekpunt.bind(this)
        };

        // Op het element zelf: één keer, ook als het element later verplaatst wordt.
        this.addEventListener('click', this.bij.klik);
        this.form.addEventListener('change', this.bij.wijzig);
        this.form.addEventListener('input', this.bij.invoer);
        this.form.addEventListener('submit', this.bij.verstuur);
        this.addEventListener('keydown', this.bij.toetsOmlaag, true);
        this.addEventListener('keyup', this.bij.toetsOmhoog, true);
      }
      if (this.aangesloten) return;
      this.aangesloten = true;

      this.getoond = this.sleutel(new URLSearchParams(window.location.search));
      document.addEventListener('click', this.bij.pagKlik);
      document.addEventListener('change', this.bij.pagWijzig);
      window.addEventListener('popstate', this.bij.terug);
      window.addEventListener('on:breakpoint-change', this.bij.breekpunt);

      this.isZijbalk = undefined;
      this.onBreekpunt();
      this.initPrijs();
    }

    disconnectedCallback() {
      if (!this.aangesloten) return;
      this.aangesloten = false;
      clearTimeout(this.timer);
      this.timer = null;
      if (this.controller) this.controller.abort();
      this.controller = null;
      document.removeEventListener('click', this.bij.pagKlik);
      document.removeEventListener('change', this.bij.pagWijzig);
      window.removeEventListener('popstate', this.bij.terug);
      window.removeEventListener('on:breakpoint-change', this.bij.breekpunt);
      document.body.classList.remove('overflow-hidden', 'af-lade-open');
    }

    /* ---------- Zijbalk (computer) of lade (telefoon en tablet) ---------- */

    onBreekpunt() {
      const zijbalk = Boolean(theme.mediaMatches && theme.mediaMatches.lg);
      if (zijbalk === this.isZijbalk) return;

      if (zijbalk) {
        // Van lade naar zijbalk (scherm breder gemaakt) met de lade open: eerst de lade netjes dicht.
        if (this.isZijbalk === false && this.hasAttribute('open')) this.close();
        this.isZijbalk = true;
        this.setAttribute('open', '');
        this.setAttribute('aria-hidden', 'false');
        this.removeAttribute('aria-modal');
        this.removeAttribute('role');
      } else {
        this.isZijbalk = false;
        this.removeAttribute('open');
        this.setAttribute('role', 'dialog');
        this.setAttribute('aria-modal', 'true');
        this.setAttribute('aria-hidden', 'true');
      }
    }

    /**
     * Opent de lade (products-toolbar.js roept dit aan vanaf de knop Filters).
     * @param {Element} [opener] - Knop die de lade opende; krijgt de focus terug bij sluiten.
     * @param {Element} [elementToFocus] - Element dat de focus krijgt.
     * @param {Function} [callback] - Na het openen.
     */
    open(opener, elementToFocus, callback) {
      if (this.isZijbalk) return;
      this.knop = opener || document.querySelector('.af-open');
      super.open(this.knop, elementToFocus, callback);
      if (this.knop) this.knop.setAttribute('aria-expanded', 'true');
      document.body.classList.add('overflow-hidden', 'af-lade-open');
    }

    /**
     * Sluit de lade; een wijziging die nog in de wachtrij staat gaat eerst de deur uit.
     * @param {Function} [callback] - Na het sluiten.
     */
    close(callback) {
      if (this.isZijbalk) return;
      const wasOpen = this.hasAttribute('open');
      if (this.timer) this.nuLaden();
      super.close(callback);
      if (this.knop) {
        this.knop.setAttribute('aria-expanded', 'false');
        this.knop.classList.remove('is-active');
      }
      document.body.classList.remove('overflow-hidden', 'af-lade-open');
      if (wasOpen) this.naarResultaten();
    }

    /* ---------- Klikken, typen, kiezen ---------- */

    onKlik(evt) {
      const groepKnop = evt.target.closest('.af-groep__knop');
      if (groepKnop) {
        this.wisselGroep(groepKnop);
        return;
      }

      const meerKnop = evt.target.closest('.af-meer');
      if (meerKnop) {
        this.wisselMeer(meerKnop);
        return;
      }

      // Klik op het icoon in de sluitknop (SideDrawer kijkt alleen naar de knop zelf).
      const sluit = evt.target.closest('.js-close-drawer');
      if (sluit && sluit !== evt.target && this.hasAttribute('open')) this.close();
    }

    onWijzig(evt) {
      const doel = evt.target;
      this.uitZijbalk = true;
      if (doel.matches('.af-vink')) {
        this.plan();
      } else if (doel.matches('[data-af-rand]')) {
        this.prijsUitVeld(true);
        this.plan();
      } else if (doel.matches('[data-af-schuif]')) {
        this.plan();
      }
    }

    onInvoer(evt) {
      const doel = evt.target;
      if (doel.matches('.af-zoek__veld')) {
        this.zoek(doel);
      } else if (doel.matches('[data-af-schuif]')) {
        this.prijsUitSchuif(doel);
      } else if (doel.matches('[data-af-rand]')) {
        this.prijsUitVeld(false);
      }
    }

    onVerstuur(evt) {
      // Enter in een prijsveld: meteen toepassen. Enter in een zoekveld verandert niets aan de filters.
      evt.preventDefault();
      this.uitZijbalk = true;
      if (this.prijs && evt.submitter == null && document.activeElement
        && document.activeElement.matches('[data-af-rand]')) {
        this.prijsUitVeld(true);
      }
      this.plan(0);
    }

    onToetsOmlaag(evt) {
      if (evt.key !== 'Escape') return;
      const veld = evt.target;
      if (veld.matches && veld.matches('.af-zoek__veld') && veld.value) {
        // Eerst de zoekterm wissen; pas een tweede Escape sluit de lade.
        evt.preventDefault();
        veld.value = '';
        this.zoek(veld);
        this.escGewist = true;
      }
    }

    onToetsOmhoog(evt) {
      if (evt.key === 'Escape' && this.escGewist) {
        this.escGewist = false;
        evt.stopPropagation();
      }
    }

    /** Labels met kruisje, Alles wissen en Wissen: zonder paginaverversing. */
    onPaginaKlik(evt) {
      const link = evt.target.closest('a[data-af-link]');
      if (!link || evt.defaultPrevented || evt.button !== 0
        || evt.metaKey || evt.ctrlKey || evt.shiftKey || evt.altKey) return;
      evt.preventDefault();
      this.uitZijbalk = false;
      this.focusNaChip = Boolean(link.closest('.af-actief'));
      this.focusNaWis = Boolean(link.closest('.af__voet'));
      this.laad(this.schoon(new URL(link.href, window.location.href).searchParams));
    }

    /** Sorteren in de werkbalk (custom-select van Enterprise). */
    onPaginaWijzig(evt) {
      const doel = evt.target;
      if (doel.tagName !== 'CUSTOM-SELECT' || doel.id !== 'products-sort-by' || !evt.detail) return;
      const veld = this.form.querySelector('[data-af-sort]');
      if (veld) veld.value = evt.detail.selectedValue;
      this.uitZijbalk = false;
      this.plan(0);
    }

    onTerug() {
      const params = new URLSearchParams(window.location.search);
      if (this.sleutel(params) === this.getoond) return;
      this.uitZijbalk = false;
      this.laad(this.schoon(params), { geschiedenis: false, vanTerug: true });
    }

    /* ---------- Groepen, Toon meer, zoeken in een lijst ---------- */

    wisselGroep(knop) {
      const groep = knop.closest('[data-af-groep]');
      const open = knop.getAttribute('aria-expanded') !== 'true';
      AstoolsFilters.zetGroep(groep, open);
      this.gebruikerOpen.set(groep.dataset.afGroep, open);
    }

    static zetGroep(groep, open) {
      const knop = groep.querySelector('.af-groep__knop');
      const paneel = groep.querySelector('.af-groep__paneel');
      if (!knop || !paneel) return;
      knop.setAttribute('aria-expanded', String(open));
      paneel.hidden = !open;
    }

    wisselMeer(knop) {
      const groep = knop.closest('[data-af-groep]');
      const aan = knop.getAttribute('aria-expanded') !== 'true';
      AstoolsFilters.zetMeer(groep, aan);
      if (aan) {
        this.gebruikerMeer.add(groep.dataset.afGroep);
      } else {
        this.gebruikerMeer.delete(groep.dataset.afGroep);
      }
    }

    static zetMeer(groep, aan) {
      const knop = groep.querySelector('.af-meer');
      if (!knop) return;
      groep.classList.toggle('is-meer', aan);
      knop.setAttribute('aria-expanded', String(aan));
      const tekst = knop.querySelector('.af-meer__tekst');
      if (tekst) tekst.textContent = aan ? knop.dataset.afMinder : knop.dataset.afMeer;
    }

    zoek(veld) {
      const groep = veld.closest('[data-af-groep]');
      if (!groep) return;
      const term = normaal(veld.value);
      groep.classList.toggle('is-zoeken', term !== '');
      let treffers = 0;
      groep.querySelectorAll('.af-optie').forEach((optie) => {
        const past = !term || normaal(optie.dataset.afTekst).includes(term);
        optie.hidden = !past;
        if (past) treffers += 1;
      });
      const geen = groep.querySelector('.af-geen');
      if (geen) geen.hidden = treffers > 0;
    }

    /* ---------- Prijs: schuif met twee knoppen en twee invoervelden ---------- */

    initPrijs() {
      const doos = this.querySelector('[data-af-prijs]');
      this.prijs = doos ? {
        doos,
        max: Number(doos.dataset.max) || 1,
        munt: doos.dataset.munt || '',
        veldMin: doos.querySelector('[data-af-rand="min"]'),
        veldMax: doos.querySelector('[data-af-rand="max"]'),
        schuifMin: doos.querySelector('[data-af-schuif="min"]'),
        schuifMax: doos.querySelector('[data-af-schuif="max"]')
      } : null;
      if (this.prijs) this.prijsBalk();
    }

    /**
     * Stand van de schuif naar een rond bedrag.
     * @param {number} stand - 0 tot en met STANDEN.
     * @returns {number}
     */
    naarBedrag(stand) {
      const { max } = this.prijs;
      if (stand <= 0) return 0;
      if (stand >= STANDEN) return max;
      const ruw = max * (stand / STANDEN) ** 2;
      let stap = 50;
      if (ruw < 100) {
        stap = 1;
      } else if (ruw < 1000) {
        stap = 5;
      } else if (ruw < 5000) {
        stap = 10;
      }
      return Math.min(max, Math.round(ruw / stap) * stap);
    }

    /**
     * Bedrag naar de stand van de schuif.
     * @param {number} bedrag - Bedrag in hele euro's (of de munt van de winkel).
     * @returns {number}
     */
    naarStand(bedrag) {
      const { max } = this.prijs;
      if (bedrag <= 0) return 0;
      if (bedrag >= max) return STANDEN;
      return Math.round(STANDEN * Math.sqrt(bedrag / max));
    }

    prijsUitSchuif(schuif) {
      const {
        max, veldMin, veldMax, schuifMin, schuifMax
      } = this.prijs;
      let van = Number(schuifMin.value);
      let tot = Number(schuifMax.value);
      if (van > tot) {
        if (schuif === schuifMin) {
          van = tot;
          schuifMin.value = van;
        } else {
          tot = van;
          schuifMax.value = tot;
        }
      }
      const bedragVan = this.naarBedrag(van);
      const bedragTot = this.naarBedrag(tot);
      veldMin.value = bedragVan > 0 ? bedragVan : '';
      veldMax.value = bedragTot < max ? bedragTot : '';
      this.prijsBalk();
    }

    /**
     * Neemt de invoervelden over in de schuif.
     * @param {boolean} definitief - Bij verlaten of Enter: afronden, begrenzen en zo nodig omdraaien.
     */
    prijsUitVeld(definitief) {
      const {
        max, veldMin, veldMax, schuifMin, schuifMax
      } = this.prijs;
      const getal = (waarde, standaard) => {
        const n = Math.round(Number(String(waarde).replace(',', '.')));
        if (String(waarde).trim() === '' || Number.isNaN(n)) return standaard;
        return Math.min(Math.max(n, 0), max);
      };
      let van = getal(veldMin.value, 0);
      let tot = getal(veldMax.value, max);
      if (definitief) {
        if (van > tot) [van, tot] = [tot, van];
        veldMin.value = van > 0 ? van : '';
        veldMax.value = tot < max ? tot : '';
      }
      schuifMin.value = this.naarStand(Math.min(van, tot));
      schuifMax.value = this.naarStand(Math.max(van, tot));
      this.prijsBalk();
    }

    prijsBalk() {
      const {
        doos, max, munt, veldMin, veldMax, schuifMin, schuifMax
      } = this.prijs;
      const van = Number(schuifMin.value);
      const tot = Number(schuifMax.value);
      doos.style.setProperty('--af-van', `${(van / STANDEN) * 100}%`);
      doos.style.setProperty('--af-tot', `${(tot / STANDEN) * 100}%`);
      // Liggen de knoppen op elkaar aan de rechterkant, dan moet de linker bovenop (anders zit hij vast).
      schuifMin.classList.toggle('is-boven', van >= tot && van > STANDEN / 2);
      // Schermlezers noemen het bedrag, niet de stand van de schuif.
      const taal = document.documentElement.lang || undefined;
      const tekst = (veld, standaard) => {
        const n = Math.round(Number(String(veld.value).replace(',', '.')));
        const bedrag = String(veld.value).trim() === '' || Number.isNaN(n) ? standaard : n;
        return `${munt}${bedrag.toLocaleString(taal)}`;
      };
      schuifMin.setAttribute('aria-valuetext', tekst(veldMin, 0));
      schuifMax.setAttribute('aria-valuetext', tekst(veldMax, max));
    }

    /* ---------- Ophalen en tekenen ---------- */

    /** De filters zoals ze nu in het formulier staan, als querystring. */
    formQuery() {
      const params = new URLSearchParams();
      const max = this.prijs ? this.prijs.max : Infinity;
      Array.from(this.form.elements).forEach((el) => {
        if (!el.name || el.disabled) return;
        if ((el.type === 'checkbox' || el.type === 'radio') && !el.checked) return;
        const waarde = String(el.value).trim();
        if (!waarde) return;
        if (el.hasAttribute('data-af-sort') && waarde === this.standaardSort) return;
        if (el.dataset.afRand === 'min' && Number(waarde) <= 0) return;
        if (el.dataset.afRand === 'max' && Number(waarde) >= max) return;
        params.append(el.name, waarde);
      });
      return params.toString();
    }

    /** Alleen de parameters die over filteren, zoeken en sorteren gaan (geen page, section_id enz.). */
    schoon(params) {
      const uit = new URLSearchParams();
      params.forEach((waarde, naam) => {
        if (!EIGEN_PARAMETER.test(naam) || waarde === '') return;
        if (naam === 'sort_by' && waarde === this.standaardSort) return;
        uit.append(naam, waarde);
      });
      return uit.toString();
    }

    /** Vergelijkbare sleutel, ongeacht volgorde, om overbodige verzoeken te herkennen. */
    sleutel(params) {
      const rijen = [];
      params.forEach((waarde, naam) => {
        if (!EIGEN_PARAMETER.test(naam) || waarde === '') return;
        if (naam === 'sort_by' && waarde === this.standaardSort) return;
        rijen.push(`${naam}=${waarde}`);
      });
      return rijen.sort().join('&');
    }

    /**
     * Plant het ophalen van de filters zoals ze nu staan. Een lopend verzoek is dan achterhaald
     * en wordt meteen afgebroken, zodat een laat antwoord een nieuwere keuze nooit overschrijft.
     * @param {number} [wacht] - Wachttijd in ms om snelle klikken te bundelen.
     */
    plan(wacht = WACHTTIJD) {
      if (this.controller) {
        this.controller.abort();
        this.controller = null;
      }
      this.volgende = this.formQuery();
      clearTimeout(this.timer);
      this.zetBezig(true);
      this.timer = setTimeout(() => {
        this.timer = null;
        this.laad(this.volgende);
      }, wacht);
    }

    nuLaden() {
      clearTimeout(this.timer);
      this.timer = null;
      this.laad(this.volgende == null ? this.formQuery() : this.volgende);
    }

    /**
     * Haalt de sectie op met deze filters en tekent filters, tellers en producten opnieuw.
     * @param {string} query - Querystring met filters en sortering.
     * @param {object} [opties]
     * @param {boolean} [opties.geschiedenis=true] - Een stap in de geschiedenis maken.
     * @param {boolean} [opties.vanTerug=false] - Aangeroepen vanuit de terug-knop.
     */
    async laad(query, { geschiedenis = true, vanTerug = false } = {}) {
      clearTimeout(this.timer);
      this.timer = null;
      const sleutel = this.sleutel(new URLSearchParams(query));
      const paginering = document.querySelector('custom-pagination');

      if (sleutel === this.getoond) {
        if (!this.controller) this.klaar(paginering);
        return;
      }

      if (this.controller) this.controller.abort();
      const controller = new AbortController();
      this.controller = controller;
      this.zetBezig(true);
      if (paginering) paginering.dataset.pauseInfiniteScroll = 'true';

      const pad = window.location.pathname;
      const url = `${pad}?${query}${query ? '&' : ''}section_id=${encodeURIComponent(this.sectieId)}`;

      try {
        const antwoord = await fetch(url, { signal: controller.signal });
        if (!antwoord.ok) throw new Error(`HTTP ${antwoord.status}`);
        const html = await antwoord.text();
        if (controller !== this.controller) return;

        const doc = new DOMParser().parseFromString(html, 'text/html');
        if (!doc.querySelector('[data-af-groepen]') || !doc.getElementById('filter-results')) {
          throw new Error('Onverwacht antwoord van de sectie');
        }

        this.teken(doc, vanTerug);
        this.getoond = sleutel;
        if (geschiedenis) {
          window.history.pushState({ afFilters: query }, '', `${pad}${query ? `?${query}` : ''}`);
        }
        if (paginering && paginering.reload) paginering.reload();
        document.dispatchEvent(new CustomEvent('on:facet-filters:updated', { bubbles: true }));
      } catch (fout) {
        if (controller.signal.aborted) return;
        // Terugval: een gewone paginaverversing met precies deze filters.
        window.location.assign(`${pad}${query ? `?${query}` : ''}`);
      } finally {
        if (controller === this.controller) {
          this.controller = null;
          this.klaar(paginering);
        }
      }
    }

    klaar(paginering) {
      this.zetBezig(false);
      if (paginering) paginering.dataset.pauseInfiniteScroll = 'false';
    }

    zetBezig(aan) {
      this.results.classList.toggle('is-loading', aan);
      this.results.setAttribute('aria-busy', String(aan));
      const toon = this.querySelector('.af__toon');
      if (toon) toon.classList.toggle('is-loading', aan);
    }

    /**
     * Zet het nieuwe antwoord op de pagina en houdt vast wat de bezoeker had openstaan.
     * @param {Document} doc - Opgehaalde sectie.
     * @param {boolean} vanTerug - Ook de sorteerkeuze in de werkbalk bijwerken.
     */
    teken(doc, vanTerug) {
      const actief = document.activeElement;
      const focusId = actief && actief !== this && this.contains(actief) ? actief.id : null;
      const zoektermen = [];
      this.querySelectorAll('.af-zoek__veld').forEach((veld) => {
        if (veld.value) zoektermen.push([veld.id, veld.value]);
      });
      const inhoud = this.querySelector('.af__inhoud');
      const scroll = inhoud ? inhoud.scrollTop : 0;

      // Filtergroepen: open/dicht en Toon meer zoals de bezoeker ze had.
      const nieuw = doc.querySelector('[data-af-groepen]');
      nieuw.querySelectorAll('[data-af-groep]').forEach((groep) => {
        const id = groep.dataset.afGroep;
        if (this.gebruikerOpen.has(id)) AstoolsFilters.zetGroep(groep, this.gebruikerOpen.get(id));
        if (this.gebruikerMeer.has(id)) AstoolsFilters.zetMeer(groep, true);
      });
      this.querySelector('[data-af-groepen]').replaceWith(document.importNode(nieuw, true));
      zoektermen.forEach(([id, waarde]) => {
        const veld = document.getElementById(id);
        if (!veld) return;
        veld.value = waarde;
        this.zoek(veld);
      });
      this.initPrijs();

      const sort = doc.querySelector('[data-af-sort]');
      const sortVeld = this.form.querySelector('[data-af-sort]');
      if (sort && sortVeld) sortVeld.value = sort.value;

      // Producten.
      this.results.innerHTML = doc.getElementById('filter-results').innerHTML;

      // Tellers en knoppen buiten de filters (werkbalk, onderkant van de lade).
      document.querySelectorAll('[data-af-sync]').forEach((el) => {
        const bron = doc.querySelector(`[data-af-sync="${el.dataset.afSync}"]`);
        if (!bron) return;
        el.innerHTML = bron.innerHTML;
        el.hidden = bron.hidden;
        if (bron.hasAttribute('href')) el.setAttribute('href', bron.getAttribute('href'));
      });

      if (vanTerug) {
        const sortOud = document.querySelector('.af-werkbalk__sort');
        const sortNieuw = doc.querySelector('.af-werkbalk__sort');
        if (sortOud && sortNieuw) sortOud.innerHTML = sortNieuw.innerHTML;
      }

      const status = document.querySelector('[data-af-status]');
      const aantal = doc.querySelector('[data-af-sync="aantal"]');
      if (status && aantal) status.textContent = aantal.textContent.trim();

      if (inhoud) inhoud.scrollTop = scroll;
      if (focusId) {
        const el = document.getElementById(focusId);
        if (el) el.focus({ preventScroll: true });
      } else if (this.focusNaChip) {
        const volgende = this.results.querySelector('.af-actief a');
        if (volgende) {
          volgende.focus({ preventScroll: true });
        } else {
          this.results.setAttribute('tabindex', '-1');
          this.results.focus({ preventScroll: true });
        }
      } else if (this.focusNaWis && this.hasAttribute('open')) {
        // Wissen onderin de lade verdwijnt zodra er niets meer gekozen is: de focus blijft in de lade.
        const wis = this.querySelector('.af__wis');
        const doel = wis && !wis.hidden ? wis : this.querySelector('.af__toon');
        if (doel) doel.focus({ preventScroll: true });
      }
      this.focusNaChip = false;
      this.focusNaWis = false;

      // Op de computer kan de bezoeker de zijbalk open- en dichtklappen (products-toolbar.js, als
      // "filters open op grote schermen" uit staat); de nieuwe productenlijst krijgt de kolommen die erbij horen.
      const kolom = this.closest('.main-products-grid__filters');
      const lijst = this.results.querySelector(':scope > .grid');
      if (kolom && lijst && lijst.dataset.filtersOpenClasses) {
        lijst.className = kolom.classList.contains('lg:js-hidden')
          ? lijst.dataset.filtersClosedClasses
          : lijst.dataset.filtersOpenClasses;
      }

      if (this.isZijbalk) this.naarResultaten(this.uitZijbalk);
      this.uitZijbalk = false;
    }

    /**
     * Scrolt naar het begin van de producten als dat boven in beeld verdwenen is.
     * @param {boolean} [alleenAlsWeg=false] - Na een klik in de zijbalk blijft de pagina staan (zoals bij
     *   Coolblue), zodat de groep waarin je kiest onder je muis blijft. Alleen als de productenlijst zo
     *   kort werd dat hij grotendeels boven het beeld verdwenen is, gaat de pagina terug naar het begin.
     */
    naarResultaten(alleenAlsWeg = false) {
      const kop = document.querySelector('store-header[data-is-sticky="true"]')
        ? parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--header-height')) || 0
        : 0;
      const vak = this.results.getBoundingClientRect();
      if (vak.top >= kop) return;
      if (alleenAlsWeg && vak.bottom > kop + (window.innerHeight - kop) / 2) return;
      window.scrollTo({ top: vak.top + window.scrollY - kop - 16, behavior: 'smooth' });
    }
  }

  customElements.define('facet-filters', AstoolsFilters);
}
